import { createContext, FC } from 'react';

import { TableContextProviderProps } from './Table.types';

export const TableContext = createContext(undefined);

const TableContextProvider: FC<TableContextProviderProps> = ({ value, children }) => {
  return <TableContext.Provider value={value}>{children}</TableContext.Provider>;
};

export default TableContextProvider;
